// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"fa","speechCardBox":"fa","speech-img-box":"fb","speechImgBox":"fb","card-content":"fc","cardContent":"fc","card-src":"fd","cardSrc":"fd"};